import { render, staticRenderFns } from "./TableListAlternative.vue?vue&type=template&id=646b5afe&"
import script from "./TableListAlternative.vue?vue&type=script&lang=js&"
export * from "./TableListAlternative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports